import { useNavigate } from 'react-router-dom';
import './style.css'
import React from 'react';

const cardStyle = {
    background: '#fdddf9',
    borderRadius: '16px',
    position: 'relative',
    // padding: '20px',
    // textAlign: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    width: '240px',
    height: '145px',
    marginTop: '100px',

};

const imageContainerStyle = {
    position: 'absolute',
    top: '-50%',
    Left: '50%',
    transform: 'translateX(50%)',
    width: '120px',
    height: '120px',
    borderRadius: '50%',
    overflow: 'hidden',
    // margin: '0 auto 15px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
};

const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
};

const titleStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333',
    paddingTop: 60,
    padding: '60px 20px 0px 20px',
    margin: 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"

};

const descriptionStyle = {
    fontSize: '14px',
    color: '#666',
    padding: "0px 20px",
    margin: 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
};



export default function ProductCard({ name, description, navigate_to, image }) {

    const navigate = useNavigate()

    return (
        <div className="card-responsive-container" style={cardStyle}>
            <div style={imageContainerStyle}>
                <img
                    src={image ?? "*"}
                    alt={name}
                    style={imageStyle}
                />
            </div>
            <h3 style={titleStyle}>{name}</h3>
            <p style={descriptionStyle}>{description ?? "คลิกเพื่อดูรายละเอียด"}</p>
            <button onClick={() => navigate(navigate_to)} className='button-product-card'>ดูเพิ่มเติม</button>
        </div>
    );
}